export const dataFields = {
  Folha: {
    callback: (item) => {
      let seq_global = Number(item.seq_global) || 0
      let folha = Math.floor((seq_global - 1) / 20) + 1
      return folha
    },
  },
  Sequência: {
    callback: (item) => {
      let seq_global = Number(item.seq_global) || 0
      let sequencia = ((seq_global - 1) % 20) + 1
      return sequencia
    },
  },
  Procedimento: {
    field: 'procedimento',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CBO: {
    field: 'cbo',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Idade: 'idade',
  Quantidade: 'quantidade',
}

export const infoHtml = ``
